// User role enumeration matching backend
export enum UserRole {
  SYSTEM_ADMIN = 'SYSTEM_ADMIN',
  UNIVERSITY_ADMIN = 'UNIVERSITY_ADMIN',
  FACULTY_ADMIN = 'FACULTY_ADMIN',
  PROFESSOR = 'PROFESSOR',
  COURSE_REPRESENTATIVE = 'COURSE_REPRESENTATIVE',
}

// Table data interfaces for UI components
export interface TenantTableData {
  id: string;
  name: string;
  description?: string;
  code?: string;
  createdAt: string;
}

export interface AdminUserTableData {
  id: string;
  name: string;
  email: string;
  role: string;
  assignedAt: string;
  userRoleId: string;
  userId: string;
  status?: 'active' | 'invited'; // Track if user has completed registration
}

// Form data interfaces
export interface TenantFormData {
  name: string;
  description?: string;
  code?: string;
}

export interface AdminInviteFormData {
  email: string;
  name?: string;
}

// Filter and search options
export interface TenantFilterOptions {
  search?: string;
  sortBy?: 'name' | 'createdAt';
  sortOrder?: 'asc' | 'desc';
}

export interface AdminUserFilterOptions {
  search?: string;
  sortBy?: 'name' | 'email' | 'assignedAt';
  sortOrder?: 'asc' | 'desc';
}

// UI state interfaces
export interface ManageUIState {
  selectedTab: number;
  isAddTenantDialogOpen: boolean;
  isAddAdminDialogOpen: boolean;
  editingTenant: TenantTableData | null;
  loadingStates: {
    tenants: boolean;
    admins: boolean;
    createTenant: boolean;
    updateTenant: boolean;
    deleteTenant: boolean;
    inviteAdmin: boolean;
    removeAdmin: boolean;
  };
}

// Error handling types
export interface ManageError {
  type: 'tenant' | 'admin' | 'general';
  operation: 'create' | 'update' | 'delete' | 'fetch' | 'invite' | 'remove';
  message: string;
  details?: unknown;
}

// Success notification types
export interface ManageSuccess {
  type: 'tenant' | 'admin';
  operation: 'create' | 'update' | 'delete' | 'invite' | 'remove';
  message: string;
}
